function initializeMenu() {
  if (
    window.innerWidth < 940 &&
    document.querySelector(".header__left-buttons-movil--toggle")
  ) {
    const hamburguerButton = document.querySelector(
        ".header__left-buttons-movil--toggle"
      ),
      fullMenu = document.querySelector(".header__navigation"),
      menuMovil = document.querySelector(".header__menu-movil"),
      innerMenuMovil = document.querySelector(".header__menu-movil--menu"),
      closeMenuMovil = document.querySelector(".header__menu-movil--close"),
      headerLi = document.querySelectorAll(".header__li--sub-menu"),
      body = document.querySelector("body"),
      menuSocials = document.querySelector(".header__menu-movil--bottom"),
      footerSocials = document.querySelector(".footer__ul");

    hamburguerButton.addEventListener("click", () => {
      menuMovil.classList.add("open");
      body.classList.add("hidden");
      innerMenuMovil.innerHTML = fullMenu.innerHTML;
      menuSocials.innerHTML = footerSocials.innerHTML;
    });
    closeMenuMovil.addEventListener("click", () => {
      menuMovil.classList.remove("open");
      body.classList.remove("hidden");
    });

    headerLi.forEach((submenu) => {
      let wrapperNav = submenu.querySelector("section"),
        handler = submenu.querySelector(".header__li--span");
      console.log(wrapperNav);
      handler.addEventListener("click", () => {
        wrapperNav.classList.toggle("sub-menu-movil-open");
      });
    });
  }
}

initializeMenu();

window.addEventListener("resize", () => {
  if (window.innerWidth < 940) {
    initializeMenu();
  }
});

const targetElement = document.querySelector("header"),
  handleSearcher = document.querySelector("#searchInPage"),
  closeSearcher = document.querySelector(".searcher__close"),
  wrapperSearcher = document.querySelector(".searcher");
handleSearcher.addEventListener("click", () => {
  wrapperSearcher.classList.add("open");
});
closeSearcher.addEventListener("click", () => {
  wrapperSearcher.classList.remove("open");
});
window.addEventListener("scroll", () => {
  if (window.scrollY > 100) {
    targetElement.classList.add("fixed");
  } else {
    targetElement.classList.remove("fixed");
  }
});
